import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        position: "relative",
        bottom: 0,
        width: "98%",
        background: "rgba(81, 80, 80, 0.5)", // Increased opacity for better visibility
        backdropFilter: "blur(15px)", // Enhanced blur effect
        WebkitBackdropFilter: "blur(15px)", // Added for Safari compatibility
        textAlign: "center",
        borderRadius: {xs: "20px", sm: "10px"}, // Responsive border radius
        py: {xs: 1, sm: 2}, // Responsive padding
        mb: {xs: 0, sm: 2}, // Responsive margin-bottom
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Added subtle shadow for depth
      }}
    >
      <Typography
        color="white"
        sx={{
          fontSize: "1rem",
          marginBottom: "3px",
          letterSpacing: ".5px",
          fontFamily: "Poppins, sans-serif",
          "@media (max-width: 600px)": {
            fontSize: "0.9rem", // Adjust font size for smaller screens
          },
        }}
      >
        Talk to us?
      </Typography>
      <Typography
        color="white"
        sx={{
          fontSize: "1.4rem",
          marginBottom: "3px",
          letterSpacing: ".5px",
          fontFamily: "Poppins, sans-serif",
          "@media (max-width: 600px)": {
            fontSize: "1.2rem", // Adjust font size for smaller screens
          },
        }}
      >
        info@clockhash.com
      </Typography>
      <Typography
        variant="body2"
        color="white"
        sx={{
          fontSize: ".8rem",
          marginBottom: "3px",
          letterSpacing: ".5px",
          fontFamily: "Poppins, sans-serif",
          "@media (max-width: 600px)": {
            fontSize: "0.7rem", // Adjust font size for smaller screens
          },
        }}
      >
        India | Netherlands | www.clockhash.com
      </Typography>
    </Box>
  );
};

export default Footer;
